import React, { Component } from 'react'
import { Row, Col } from 'antd'
import { observer, inject } from "mobx-react"
import BarEcharts from 'app/components/normal/BarEcharts'

const TYPE = [{
  name: "data",
  title: "报告",
  unit: "份",
  color: ["#87c5ff", "rgba(135, 197, 255, 0.2)"]
}]
@inject("store") @observer
export default class extends Component {
  componentDidMount() {
    this.props.store.getChartData()
  }
  render() {
    const { store: { chartData } } = this.props
    return (
      <Row className="dashboard-chart-list">
        {TYPE.map((item, index) => {
          return (
            <Col span={24} key={index}>
              <BarEcharts
                data={chartData[item.name]}
                type={item}
                mold='single'
              />
            </Col>
          )
        })}
      </Row>

    )
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/preview/bill/containers/DataChart.js